import { signalStore, withHooks, withState } from "@ngrx/signals";
import { initialUserProfileState } from "./user-profile.state";
import { withUserProfileApiMethods } from "./user-profile.methods.api";
import { withUserProfileStateMethods } from "./user-profile.methods.state";
import { withUserProfileComputed } from "./user-profile.computed";

export const UserProfileStore = signalStore(
    { providedIn: 'root' },
    withState(initialUserProfileState),
    withUserProfileApiMethods,
    withUserProfileStateMethods,
    withUserProfileComputed,
    withHooks({
        onInit(store) {
            store.rehydrateFromStorage();
        }
    })
);
